import React, { useState } from 'react';
//import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { inject, observer } from 'mobx-react';

import Tab from '@material-ui/core/Tab';
import Container from '@material-ui/core/Container';

import compose from 'helpers/compose';
import Tabs from 'components/CustomTabs/CustomTabs';
//import AccountStepper from 'components/AccountStepper/AccountStepper';

import { DetailPage } from 'pages/Accounts/Detail/enums';
//import Documents from 'pages/Accounts/Detail/Documents/Documents';
import PersonalData from 'pages/Accounts/Edit/Contract/PersonalData/PersonalData';
import DetailBankAccounts from 'pages/Accounts/Profile/BankAccounts/BankAccounts';
import { RootStore } from 'stores/rootStore';
//import { Params } from 'pages/Accounts/Edit/accountEditRoutes';
import { AccountDetailStore } from 'stores/account/accountDetailStore';
import ConfirmEditDialog from 'pages/Accounts/Detail/components/ConfirmEditDialog';

interface Props {
  rootStore: RootStore;
  accountDetailStore: AccountDetailStore;
}

const Profile: React.FC<Props> = ({ rootStore, accountDetailStore }) => {
  //const { accountId } = useParams<Params>();
  const { t } = useTranslation();
  const [tab, setTab] = useState<DetailPage | undefined>(DetailPage.PERSONAL_DATA); // default tab

  // value?: number should be value: number, but the @material-ui typing is bugged
  const handleTabChange = (_event: React.ChangeEvent<{}>, value?: DetailPage) => {
    if (value !== undefined && !accountDetailStore.editMode) {
      setTab(value);
      accountDetailStore.setFlowStartPage(value);
    }
  };

  // FIXME: DRF / flows

  return (
    <>
      <Container maxWidth="md">
        {/*accountDetailStore.editMode ? (
          <AccountStepper
            steps={[
              { id: DetailPage.PERSONAL_DATA, title: 'accountDetail_personalData' },
              { id: DetailPage.BANK_ACCOUNTS, title: 'accountDetail_bankAccounts' },
              { id: DetailPage.DOCS, title: 'accountDetail_documents' },
            ]}
            activeId={tab}
            onChange={handleTabChange}
          />
        ) : (
        )*/}

        <Tabs value={tab} onChange={handleTabChange}>
          <Tab
            value={DetailPage.PERSONAL_DATA}
            disabled={accountDetailStore.editMode}
            label={t('accountDetail_personalData')}
          />
          <Tab
            value={DetailPage.BANK_ACCOUNTS}
            disabled={accountDetailStore.editMode}
            label={t('accountDetail_bankAccounts')}
          />
        </Tabs>

        {tab === DetailPage.PERSONAL_DATA && (
          <PersonalData
            detailMode
            tabChange={setTab}
            //readOnly={!accountDetailStore.editMode}
            readOnly
            //mode={accountDetailStore.mode}
            detailStore={accountDetailStore}
          />
        )}
        {tab === DetailPage.BANK_ACCOUNTS && (
          <DetailBankAccounts
            tabChange={setTab}
            readOnly
            accountDetailStore={accountDetailStore}
            //readOnly={!accountDetailStore.editMode}
            // openEdit={() => accountDetailStore.edit(DetailSection.PERSONAL, DetailTab.BANK_ACCOUNTS)}
          />
        )}
        {/*tab === DetailPage.DOCS && (
          <Documents
            accountDetailStore={accountDetailStore}
            flow={DetailSection.PERSONAL}
            tabChange={setTab}
            accountId={accountId}
          />
        )*/}
      </Container>
      <ConfirmEditDialog store={accountDetailStore} />
    </>
  );
};

export default compose(inject('rootStore'), observer)(Profile);
